module.exports = "<div class=\"cardContainer\">\n  <span load-image=\"{{image}}\" class=\"icon-large icon-center\" [style.backgroundColor]=\"backgroundImageColor\" role=\"img\" [attr.aria-label]=\"imgAltText\"></span>\n  <h2>{{header}}</h2>\n  <div class=\"description-text\">\n    <h5>{{description}}</h5>\n    <a *ngIf=\"learnMoreLink\" target=\"_blank\" [href]=\"learnMoreLink\">{{'learnMore' | translate}}</a>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/controls/card-info-control/card-info-control.component.html
// module id = ./src/app/controls/card-info-control/card-info-control.component.html
// module chunks = main